const ContactPage = () => {
    return (
      <div>contact Page</div>
    )
  }
  
  export default ContactPage;